//
//
//
//
//
//
//
//
//
//
//
//

import UiLazyImg from "@/components/Ui/UiLazyImg.vue";

export default {
  name: "ShowMediaAsset",
  components: {
    UiLazyImg
  },
  props: {
    source: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'image'
    },
    breakpointSource: {
      type: String,
      default: ''
    },
    mediaBreakpoint: {
      type: String,
      default: 'smAndDown'
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    canPlay: {
      type: Boolean,
      default: false
    },
    useCdnOptimize: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    mediaSource(val, oldVal) {
      if (this.isVideo && val && oldVal && val !== oldVal) {
        this.$refs?.video?.load();
      }
    }
  },
  computed: {
    isVideo() {
      return this.type.includes('video');
    },
    mediaSource() {
      return this.breakpointSource && this.$vuetify.breakpoint[this.mediaBreakpoint] ? this.breakpointSource : this.source;
    }
  }
}
